//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	//#endregion

	//#region Style vars
	let imageSize = '20rem';
	let AYRContainerStyleSize = '120vh';
	let AYRContainerStylePaddingTop = 0;
	let mainTitleTextAlign = 'center';
	//#endregion

	//#region seting vars based off params
	if (size === `lg`) {
		imageSize = '18rem';
	}
	if (size === 'md') {
		imageSize = '14rem';
	}
	if (size === 'sm') {
		imageSize = '12rem';
	}
	if (isMobile) {
		AYRContainerStyleSize = 'auto';
		imageSize = '18rem';
		AYRContainerStylePaddingTop = 1;
		mainTitleTextAlign = 'center';
	}
	//#endregion

	return {
		AYRContainerStyle: () => {
			return {
				display: 'flex',
				flexWrap: !isMobile ? 'unset' : 'wrap',
				width: '100%',
				height: AYRContainerStyleSize,
				padding: `${AYRContainerStylePaddingTop}rem ${minimumMarginX}rem 0rem ${minimumMarginX}rem`,
				overflowX: `hidden`,
				overflowY: `hidden`,
			};
		},
		mainTitleText: () => {
			return {
				color: 'black',
				textAlign: mainTitleTextAlign,
			};
		},
		seceondMainTitleText: () => {
			return {
				color: 'black',
				textAlign: mainTitleTextAlign,
				fontSize: isMobile ? '3rem' : '4rem',
			};
		},
		dskAYRLeftColStyle: () => {
			return {
				marginTop: 'auto',
				marginBottom: 'auto',
			};
		},
		dskAYRRightColClasses: () => {
			return 'col-4';
		},
		dskAYRLeftColClasses: () => {
			return 'col-8 me-3';
		},
		genericTextStyle: larger => {
			let fontSize = '1rem';
			if (larger && size === 'xl') {
				fontSize = '2rem';
			}
			return {
				marginTop: '1rem',
				fontSize: fontSize,
			};
		},
		imageStyle: ({order}) => {
			let marginLeft = 0;
			let marginRight = 0;
			if (size === 'sm' || size === 'md') {
				marginLeft = '2rem';
			}
			if (isMobile) {
				marginRight = 'auto';
				marginLeft = 'auto';
			}
			let style = {
				width: imageSize,
				height: imageSize,
				borderRadius: '10px',
				marginLeft: marginLeft,
				marginRight: marginRight,
			};
			if (order === 1) {
				style.transform = `rotate(20deg)`;
				style.marginTop = '4rem';
			} else if (order === 2) {
				let marginTop = `-4rem`;
				if (size === 'sm') {
					marginTop = `8rem`;
				}
				if (size === 'md') {
					marginTop = `2rem`;
				}
				if (isMobile) {
					marginTop = `5rem`;
				}
				style.zIndex = 2;
				style.transform = `rotate(340deg)`;
				style.marginTop = marginTop;
			}
			return style;
		},
		dskAYRRightColStyle: () => {
			return {
				display: 'flex',
				flexDirection: 'column',
				margin: `auto 0`,
			};
		},
	};
}

export default Styles;
